export default __webpack_public_path__ + "94270581da039b225d71ba0e3c933c84.gif";